import { render, staticRenderFns } from "./LayoutSearch.vue?vue&type=template&id=c36626da&scoped=true&"
import script from "./LayoutSearch.vue?vue&type=script&lang=js&"
export * from "./LayoutSearch.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSearch.vue?vue&type=style&index=0&id=c36626da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36626da",
  null
  
)

export default component.exports